import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import BrandServices from '../../services/BrandServices';
import VehicleServices from '../../services/VehicleServices';

function VehicleUpdate({ vehicle, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        name: '',
        type: '',
        brand: '',

    });
    const [brands, setBrands] = useState([]);
    useEffect(() => {
        const fetchBrands = async () => {
            try {
                if (formValues.type) {
                    const res = await BrandServices.getBrandByType(formValues.type);
                    if (res.status) {
                        setBrands(res.data);
                    } else {
                        alert('Failed to fetch brands');
                    }
                } else {
                    setBrands([]); // Clear brands if no type is selected
                }
            } catch (error) {
                console.error('Error fetching brands', error);
                alert('Failed to fetch brands');
            }
        };
        fetchBrands();
    }, [formValues.type]); // Update when type changes

    useEffect(() => {
        if (vehicle) {
            setFormValues({
                type: vehicle?.type || '',
                name: vehicle?.name || '',
                brand: vehicle?.brand?._id || '',


            });

        }
    }, [vehicle]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };



    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const formData = new FormData();
            if (!vehicle._id) {
                alert('Vehicle ID is missing');
                return;
            }

            await VehicleServices.updateVehicle(vehicle._id, formValues); 
            alert('Vehicle updated successfully');
            onSuccess();
            closeModal();
        } catch (error) {
            console.error('Failed to update Vehicle', error);
            alert('Failed to update Vehicle');
        }
    };


    return (
        <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title"> Edit Vehicle</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="container-box px-5">
                            <div className="container-box-inner table-reponsive-tabe">
                                <div className="page-details">
                                    <form onSubmit={handleSubmit}>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>Select your Vehicle Type</label>
                                                    <select
                                                        className="form-control"
                                                        value={formValues.type}
                                                        onChange={handleInputChange}
                                                        name="type"
                                                    >
                                                        <option value="">--Select Type--</option>
                                                        <option value="Car">Car</option>
                                                        <option value="Bike or 3-Wheeler">Bike or 3-Wheeler</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>Select your Brand</label>
                                                    <select
                                                        name="brand"
                                                        className="form-control"
                                                        value={formValues.brand}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select a brand</option>
                                                        {brands.map((brand) => (
                                                            <option key={brand?._id} value={brand?._id}>
                                                                {brand?.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>Enter Car Name</label>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        value={formValues.name}
                                                        onChange={handleInputChange}
                                                        placeholder="Car Name"
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <button className="submit-green-btn">Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VehicleUpdate;
